import React, { useMemo } from "react";
import { Row, Col } from 'reactstrap';

import CheckListProcessEntityTable from "../../../check_list/process/entity_table";
import { fetchCustomFieldValue, isAuthorizedCustomFieldToUser } from "../../../helper/custom_field/helper";

const AbstractCheckListProcessTable = props => {
  const {
    currentUser,
    checkListEntities,
    data,
    configuration:{
      defaultRequestParams,
      context
    },
    callbacks:{
      callbackHandleProcessData
    },
    errors
  } = props;

  const {
    customFields,
  } = data;

  const tableColumnsDefault = [
    {
      field: 'identifier',
      header: I18n.t('activerecord.attributes.abstract/entity.identifier'),
      body: (row) => {
        return row?.identifier || I18n.t('no_entry');
      },
      filter: {
        enabled: true,
        placeholder: 'Ingrese el identificador',
        inputType: 'text',
        filterrific: {
          search: 'search_query'
        }
      },
    }
  ]

  const tableColumnsCustomFields = useMemo(() => {
    return _.map(customFields, function (customField) {
      return {
        field: `custom_fields.${ customField.code }`,
        header: _.capitalize(customField.label),
        body: (row) => {
          return fetchCustomFieldValue(customField, row.custom_fields[customField.code], currentUser)
        },
        filter: {
          enabled: true,
          placeholder: `Ingrese ${ _.capitalize(customField.label) }`,
          filterrific: {
            search: `search_by_key_custom_fields`,
            searchKey: customField.code
          }
        },
        configuration: {
          isCustomField: true
        }
      }
    })
  }, [])

  const tableColumns = useMemo(() => {
    let columns = _.concat(
      tableColumnsDefault,
      tableColumnsCustomFields
    )

    return _.compact(columns)
  }, [])

  return(
    <Row>
      <Col md={12}>
        <CheckListProcessEntityTable
          checkListEntities={ checkListEntities }
          dataTableConfiguration={{
            columns: tableColumns
          }}
          configuration={{
            showDistributionListFilter: false,
            entityKey: 'entities',
            defaultRequestParams: defaultRequestParams,
            context: context
          }}
          routes = {{
            indexEntitiesPath: Routes.abstract_entities_path
          }}
          callbacks={{
            callbackHandleProcessData: callbackHandleProcessData
          }}
          errors={ errors }
        />
      </Col>
    </Row>
  )

}

export default AbstractCheckListProcessTable
